export default __webpack_public_path__ + "static/media/volunteer.ffd40895.jpg";